import { useEffect, useState } from 'react';

/**
 * Custom hook for state that persists to localStorage
 * @param {string} key - localStorage key
 * @param {*} defaultValue - default value if nothing in localStorage
 * @returns {[any, function]} - [state, setState]
 */
export const usePersistedState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    try {
      const item = localStorage.getItem(key);

      return item ? JSON.parse(item) : defaultValue;
    }
    catch (error) {
      console.warn(`Error reading localStorage key "${key}":`, error);

      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    }
    catch (error) {
      console.warn(`Error setting localStorage key "${key}":`, error);
    }
  }, [key, state]);

  return [state, setState];
};
